import {
  Document,
} from '../../../../types/models';
import SynchronousDocumentOperation from './synchronous';

export default class SetReadAloudOperation extends SynchronousDocumentOperation {
  readonly type = 'set-read-aloud';

  isEnabled: boolean;

  constructor(documentId: string, isEnabled: boolean) {
    super(documentId);
    this.isEnabled = isEnabled;
  }

  apply(document: Document): Document {
    return {
      ...document,
      meta: {
        ...document.meta,
        hasReadAloud: this.isEnabled,
      },
    };
  }
}
